import React from 'react';
import Tooltip from '../Tooltip';

// Showing a tooltip when hovering over a disabled button is a common UI pattern to show why a
// button is adisabled. The Tooltip component requires its containing element to support
// mouse events correctly, and it turns out that the browser disabled certain mouse events on
// disabled buttons.
//
// So, render a transparent absolutely positioned div overtop of the button. This div does support
// all the required mouse events, so the tooltip functions.
//
// However, this is a hack. Really, some work should be put into how to re-enable these mouse events
// on the density ui button.
const DisabledButtonTooltip: React.FunctionComponent<any> = (props) => (
  <Tooltip
    {...props}
    target={
      <div style={{position: 'relative', cursor: 'not-allowed'}}>
        {/* The transparent div: */}
        <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}} />
        {props.target}
      </div>
    }
  />
)

export default DisabledButtonTooltip;
